import { Modal, Button, Alert } from "react-bootstrap";
import { IBillingDetail } from "@nkr/models/index";
import { ConfirmTableWrapper } from "../styles";

interface IProps {
    show: boolean,
    data: IBillingDetail,
    onConfirmed: () => void,
    onCancel: () => void
}

const ConfirmBilledManually = (props: IProps) => {
    if (props.data == null)
        return null;

    const { billableNephrectomy } = props.data;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Billed Manually Confirmation</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Alert bsStyle='warning' className="text-center">
                    Are you sure you want to mark the following as billed manually?
                </Alert>

                <ConfirmTableWrapper bordered>
                    <tbody>
                        <tr>
                            <th>TXP Date</th>
                            <td>{billableNephrectomy.transplantDate}</td>
                        </tr>

                        <tr>
                            <th>Swap #</th>
                            <td>{billableNephrectomy.chainId}/{billableNephrectomy.clusterNumber}/{billableNephrectomy.positionNumber}</td>
                        </tr>

                        <tr>
                            <th>Donor</th>
                            <td>{billableNephrectomy.donor.alias} @ {billableNephrectomy.donor.center.alias}</td>
                        </tr>

                        <tr>
                            <th>Recipient</th>
                            <td>{billableNephrectomy.recipient.alias} @ {billableNephrectomy.recipient.center.alias}</td>
                        </tr>

                        <tr>
                            <th>Claim Type</th>
                            <td>{props.data.claimType}</td>
                        </tr>
                    </tbody>
                </ConfirmTableWrapper>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="primary" onClick={props.onConfirmed}>Yes, Bill Manually</Button>
                <Button onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmBilledManually;